import {GETUSER,EMPTYUSERINFO,GETADDRESSINFO,GETUSERID} from './types'
// import getters from './getters'
// 用于具体改变数据
export default {
    //获取用户ID
    [GETUSERID](state, user) {
        state.userId = user.userId;
        localStorage.setItem("userId", user.userId);
    },
    //获取用户信息
    [GETUSER](state, user) {
        state.isLogin = true;
        state.userInfo = user;
        localStorage.setItem("userInfo", window.JSON.stringify(user));
        localStorage.setItem("isLogin", state.isLogin);
    },
    //获取地址信息
    [GETADDRESSINFO](state, addressInfo) {
        state.currentAddress = addressInfo.currentAddress;
        localStorage.setItem("recentVisit", JSON.stringify(addressInfo.recentVisit));
        localStorage.setItem("currentAddress", state.currentAddress);
        localStorage.setItem("cityName", state.cityName);
    },
    //退出登录
    [EMPTYUSERINFO](state, data) {
        state.isLogin = data.isLogin;
        state.userInfo = data.user;
        localStorage.setItem("userInfo", window.JSON.stringify(data.user));
        localStorage.setItem("userId", '');
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js